import { render, staticRenderFns } from "./ProductZoomGallery.vue?vue&type=template&id=4b8a56ac&scoped=true&"
import script from "./ProductZoomGallery.vue?vue&type=script&lang=js&"
export * from "./ProductZoomGallery.vue?vue&type=script&lang=js&"
import style0 from "./ProductZoomGallery.vue?vue&type=style&index=0&id=4b8a56ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8a56ac",
  null
  
)

export default component.exports